/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserResponse } from '../../models/user-response';

export interface IdentityControllerGetAll$Params {
  roles?: Array<number>;
  related_registry_id?: number;
  query?: string;
  limit: number;
  skip: number;
}

export function identityControllerGetAll(http: HttpClient, rootUrl: string, params: IdentityControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('roles', params.roles, {});
    rb.query('related_registry_id', params.related_registry_id, {});
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserResponse;
      }>;
    })
  );
}

identityControllerGetAll.PATH = '/identity';
